export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.b772d5a2.worker.js");
}
